{
  "about.blocks": "Moderat servitores",
  "about.contact": "Contacter:",
  "about.disclaimer": "Mastodon es programmatura líber e con fonte apert, e un marca de fabrica de Mastodon dGmbH.",
  "about.domain_blocks.no_reason_available": "Rason ne disponibil",
  "about.domain_blocks.preamble": "Mastodon generalmen possibilisa regardar li contenete de, e li interaction con usatores de quelcunc altri servitor in li fediverse. Ci trova se li exceptiones fat de ti-ci particulari servitor.",
  "about.domain_blocks.silenced.explanation": "Generalmen, li profiles e contenete de ti-ci servitor ne va aparir, except si on sercha les explicitmen o optionalisa it per sequer.",
  "about.domain_blocks.silenced.title": "Limitat",
  "about.domain_blocks.suspended.explanation": "Necun data de ti-ci servitor va esser tractat, inmagasinat o exchangeat, quel inpossibilisa li interaction o comunication de usatores de ti-ci servitor.",
  "about.domain_blocks.suspended.title": "Suspendet",
  "about.not_available": "On ne ha disponibilisat ti-ci information sur ti-ci servitor.",
  "about.powered_by": "Decentralisat social medie disponibilisat de {mastodon}",
  "about.rules": "Regules del servitor",
  "account.add_or_remove_from_list": "Adjunter o remover de listes",
  "account.badges.bot": "Automatisat",
  "account.badges.group": "Gruppe",
  "account.block": "Bloccar @{name}",
  "account.block_domain": "Bloccar dominia {domain}",
  "account.block_short": "Bloccar",
  "account.blocked": "Bloccat",
  "account.cancel_follow_request": "Anullar sequer",
  "account.copy": "Copiar ligament al profil",
  "account.direct": "Privatmen mentionar @{name}",
  "account.disable_notifications": "Cessa notificar me quande @{name} posta",
  "account.edit_profile": "Redacter profil",
  "account.enable_notifications": "Notificar me quande @{name} posta",
  "account.endorse": "Recomandar sur profil",
  "account.follow": "Sequer",
  "account.follow_back": "Sequer reciprocmen",
  "account.followers": "Sequitores",
  "account.followers.empty": "Ancor nequi seque ti-ci usator.",
  "account.following": "Sequent",
  "account.follows.empty": "Ti-ci usator ancor ne seque quemcunc.",
  "account.go_to_profile": "Ear a profil",
  "account.hide_reblogs": "Celar boosts de @{name}",
  "account.in_memoriam": "In Memoriam.",
  "account.joined_short": "Adheret",
  "account.languages": "Changear lingues de subscrition",
  "account.link_verified_on": "Proprietá de ti-ci ligament esset verificat ye {date}",
  "account.locked_info": "Li statu de confidentialitá de ti-ci conto es configurat quam cludet. Li proprietario decide manualmen qui posse sequer.",
  "account.media": "Medie",
  "account.mention": "Mentionar @{name}",
  "account.moved_to": "{name} ha indicat que su nov conto es ja:",
  "account.mute": "Silentiar @{name}",
  "account.mute_notifications_short": "Silentiar notificationes",
  "account.mute_short": "Silentiar",
  "account.muted": "Silentiat",
  "account.no_bio": "Null descrition providet.",
  "account.open_original_page": "Aperter li págine original",
  "account.posts": "Postas",
  "account.report": "Raportar @{name}",
  "account.requested_follow": "{name} ha petit sequer te",
  "account.share": "Distribuer li profil de @{name}",
  "account.show_reblogs": "Monstrar boosts de @{name}",
  "account.unblock": "Desbloccar @{name}",
  "account.unblock_domain": "Desbloccar dominia {domain}",
  "account.unblock_short": "Desbloccar",
  "account.unendorse": "Ne recomandar sur profil",
  "account.unfollow": "Dessequer",
  "account.unmute": "Dessilentiar @{name}",
  "account.unmute_notifications_short": "Dessilentiar notificationes",
  "account.unmute_short": "Dessilentiar",
  "account_note.placeholder": "Clicca por adjunter un nota",
  "admin.dashboard.daily_retention": "Usator-retention per die pos registration",
  "admin.dashboard.monthly_retention": "Usator-retention per mensu pos registration",
  "admin.dashboard.retention.average": "Medial",
  "admin.dashboard.retention.cohort": "Mensu de registration",
  "admin.dashboard.retention.cohort_size": "Nov usatores",
  "admin.impact_report.instance_accounts": "Conto-profiles to-ci vell deleter",
  "admin.impact_report.instance_followers": "Sequitores queles nor usatores vell perdir",
  "admin.impact_report.instance_follows": "Sequitores queles lor usatores vell perdir",
  "admin.impact_report.title": "Resumate de impact",
  "alert.rate_limited.message": "Ples reprovar pos {retry_time, time, medium}.",
  "alert.rate_limited.title": "Frequentie limitat",
  "alert.unexpected.message": "Un ínexpectat erra ha evenit.",
  "alert.unexpected.title": "Ups!",
  "announcement.announcement": "Proclamation",
  "attachments_list.unprocessed": "(íntractat)",
  "audio.hide": "Celar audio",
  "block_modal.remote_users_caveat": "Noi va petir que li servitor {domain} mey respecter tui decision. Támen, obedientie ne es garantit pro que chascun servitor gere bloccas diferentmen. Possibilmen public postas va restar visibil a usatores de inloggat.",
  "block_modal.show_less": "Monstrar minu",
  "block_modal.show_more": "Monstrar plu",
  "block_modal.they_will_know": "Va esser conscient que tu ha bloccat.",
  "block_modal.title": "Bloccar usator?",
  "boost_modal.combo": "Li proxim vez tu posse pressar {combo} por passar to-ci",
  "bundle_column_error.copy_stacktrace": "Copiar erra-raporte",
  "bundle_column_error.error.body": "Li demandat págine ne posset esser rendit. Fórsan it es un problema in nor code, o un problema de compatibilitá con li navigator.",
  "bundle_column_error.error.title": "O ve!",
  "bundle_column_error.network.body": "Un erra evenit durant li cargation de ti-ci págine, possibilmen pro un temporari problema de tui conexion del internet o de ti-ci servitor.",
  "bundle_column_error.network.title": "Erra de retage",
  "bundle_column_error.retry": "Provar denov",
  "bundle_column_error.return": "Retornar al comense",
  "bundle_column_error.routing.body": "Li demandat págine ne trovat se. Esque tu es cert que li URL in li adresse-barre es corect?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Cluder",
  "bundle_modal_error.retry": "Provar denov",
  "closed_registrations.other_server_instructions": "Pro que Mastodon es decentralisat, on posse crear un conto che un altri servitor e ancor interacter con ti-ci.",
  "closed_registrations_modal.description": "Crear un conto che {domain} ne es possibil actualmen, ma ples memorar que on ne besona un conto specificmen che {domain} por usar Mastodon.",
  "closed_registrations_modal.find_another_server": "Serchar altri servitor",
  "closed_registrations_modal.preamble": "Mastodon es descentralisat, do on posse ser e interacter con quicunc che ti-ci servitor, sin egarda de u on crea su conto. On mem posse self-albergar it!",
  "closed_registrations_modal.title": "Registrar sur Mastodon",
  "column.about": "Information",
  "column.blocks": "Bloccat usatores",
  "column.bookmarks": "Marcatores",
  "column.community": "Local témpor-linea",
  "column.direct": "Privat mentiones",
  "column.directory": "Navigar profiles",
  "column.domain_blocks": "Bloccat dominia",
  "column.favourites": "Favorites",
  "column.firehose": "Témpor-lineas",
  "column.follow_requests": "Petitiones de sequer",
  "column.home": "Comense",
  "column.lists": "Listes",
  "column.mutes": "Silentiat usatores",
  "column.notifications": "Notificationes",
  "column.pins": "Pinglat postas",
  "column.public": "Federat témpor-linea",
  "column_back_button.label": "Retornar",
  "column_header.hide_settings": "Celar parametres",
  "column_header.moveLeft_settings": "Mover columne al levul",
  "column_header.moveRight_settings": "Mover columne al dextri",
  "column_header.pin": "Pinglar",
  "column_header.show_settings": "Monstrar parametres",
  "column_header.unpin": "Despinglar",
  "community.column_settings.local_only": "Solmen local",
  "community.column_settings.media_only": "Solmen medie",
  "community.column_settings.remote_only": "Solmen external",
  "compose.language.change": "Changear lingue",
  "compose.language.search": "Serchar lingues...",
  "compose.published.body": "Posta publicat.",
  "compose.published.open": "Aperter",
  "compose.saved.body": "Posta conservat.",
  "compose_form.direct_message_warning_learn_more": "Aprender plu",
  "compose_form.encryption_warning": "Postas in Mastodon ne es inciffrat de comense a fine. Ne posta quelcunc information sensitiv per Mastodon.",
  "compose_form.hashtag_warning": "Ti-ci posta ne va esser listat sur quelcunc hashtag pro que it ne es public. Solmen public postas posse esser serchat per hashtag.",
  "compose_form.lock_disclaimer": "Tui conto ne es {locked}. Quicunc posse sequer te por vider tui postas solmen por sequitores.",
  "compose_form.lock_disclaimer.lock": "cludet",
  "compose_form.placeholder": "Quo es in tui spiritu?",
  "compose_form.poll.duration": "Duration del balotation",
  "compose_form.poll.multiple": "Selection multiplic",
  "compose_form.poll.option_placeholder": "Option {number}",
  "compose_form.poll.switch_to_multiple": "Changea li balotation por permisser multiplic selectiones",
  "compose_form.poll.switch_to_single": "Changea li balotation por permisser un singul selection",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Postar",
  "compose_form.reply": "Responder",
  "compose_form.save_changes": "Actualisar",
  "compose_form.spoiler.marked": "Remover avise pri li contenete",
  "compose_form.spoiler.unmarked": "Adjunter avise pri li contenete",
  "compose_form.spoiler_placeholder": "Advertiment de contenete (optional)",
  "confirmation_modal.cancel": "Anullar",
  "confirmations.block.confirm": "Bloccar",
  "confirmations.delete.confirm": "Deleter",
  "confirmations.delete.message": "Esque tu vermen vole deleter ti-ci posta?",
  "confirmations.delete_list.confirm": "Deleter",
  "confirmations.delete_list.message": "Esque tu vermen vole permanentmen deleter ti-ci liste?",
  "confirmations.discard_edit_media.confirm": "Forjettar",
  "confirmations.discard_edit_media.message": "Tu have ínconservat changes al descrition de medie o al previse, forjettar les sin egarda?",
  "confirmations.logout.confirm": "Exear",
  "confirmations.logout.message": "Esque tu vermen vole exear?",
  "confirmations.mute.confirm": "Silentiar",
  "confirmations.redraft.confirm": "Deleter & redacter",
  "confirmations.redraft.message": "Esque tu vermen vole deleter ti-ci posta e redacter it? Favorites e boosts va esser perdit, e responses al posta original va esser orfanat.",
  "confirmations.unfollow.confirm": "Dessequer",
  "conversation.delete": "Deleter conversation",
  "conversation.mark_as_read": "Marcar quam leet",
  "conversation.open": "Vider conversation",
  "conversation.with": "Con {names}",
  "copy_icon_button.copied": "Copiat al Paperiere",
  "copypaste.copied": "Copiat",
  "copypaste.copy_to_clipboard": "Copiar al Paperiere",
  "directory.federated": "Del conosset fediverse",
  "directory.local": "De solmen {domain}",
  "directory.new_arrivals": "Nov arivantes",
  "directory.recently_active": "Recentmen activ",
  "disabled_account_banner.account_settings": "Parametres del conto",
  "disabled_account_banner.text": "Tui conto {disabledAccount} es actualmen desactivisat.",
  "dismissable_banner.community_timeline": "Tis-ci es li postas max recent de gente con contos che {domain}.",
  "dismissable_banner.dismiss": "Demisser",
  "domain_block_modal.block": "Bloccar servitor",
  "domain_block_modal.block_account_instead": "Altrimen, bloccar @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Persones de ti servitor posse interacter con tui old postas.",
  "domain_block_modal.they_cant_follow": "Nequi de ti-ci servitor posse sequer te.",
  "domain_block_modal.they_wont_know": "Ne va esser conscient pri li bloccada.",
  "domain_block_modal.title": "Bloccar dominia?",
  "domain_block_modal.you_wont_see_posts": "Tu ne va vider postas ni notificationes de usatores sur ti-ci servitor.",
  "domain_pill.activitypub_lets_connect": "It possibilisa tui conexiones e interactiones con persones ne solmen sur Mastodon, ma anc tra diferent social aplis.",
  "domain_pill.activitypub_like_language": "ActivityPub es li lingue usat de Mastodon por parlar con altri social retages.",
  "domain_pill.server": "Servitor",
  "domain_pill.their_handle": "Identificator:",
  "domain_pill.their_server": "Su digital hem e omni su postas.",
  "domain_pill.their_username": "Su unic identificator sur su servitor. It es possibil que altri servitores va haver usatores con li sam nómine.",
  "domain_pill.username": "Usator-nómine",
  "domain_pill.whats_in_a_handle": "Ex quo consiste un identificator?",
  "domain_pill.who_they_are": "Pro que identificatores informa qui e u un person is, tu posse interacter con persones tra li rete social de <button>ActivityPub-usant platformes</button>.",
  "domain_pill.who_you_are": "Pro que tui identificator informa qui e u tu es, persones posse interacter con te tra li rete social de <button>ActivityPub-usant platformes</button>.",
  "domain_pill.your_handle": "Tui identificator:",
  "domain_pill.your_server": "Tui digital hem, u trova se omni tui postas. Si it ne plese te, tu posse transferer ad un altri servitor quandecunc e tui sequitores con te.",
  "domain_pill.your_username": "Tui unic identificator sur ti-ci servitor. It es possibil que altri servitores va haver usatores con li sam nómine.",
  "embed.instructions": "Inbedar ti-ci posta per copiar li code in infra.",
  "embed.preview": "Vi qualmen it va aspecter:",
  "emoji_button.activity": "Activitá",
  "emoji_button.clear": "Efaciar",
  "emoji_button.custom": "Custom",
  "emoji_button.flags": "Flaggas",
  "emoji_button.food": "Manjage & Trincage",
  "emoji_button.label": "Inserter emoji",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "Null acordant emoji trovat",
  "emoji_button.objects": "Objectes",
  "emoji_button.people": "Gente",
  "emoji_button.recent": "Frequentmen usat",
  "emoji_button.search": "Sercha...",
  "emoji_button.search_results": "Resultates de sercha",
  "emoji_button.symbols": "Simboles",
  "emoji_button.travel": "Viageation & Locos",
  "empty_column.account_hides_collections": "Ti-ci usator ha selectet ne publicar ti-ci information",
  "empty_column.account_suspended": "Conto suspendet",
  "empty_column.account_timeline": "Null postas ci!",
  "empty_column.account_unavailable": "Profil índisponibil",
  "empty_column.blocks": "Tu ancor ha bloccat null usatores.",
  "empty_column.bookmarked_statuses": "Tu ancor have null marcat postas. Quande tu marca un, it va aparir ci.",
  "empty_column.community": "Li local témpor-linea es vacui. Scri alquo publicmen por initiar la festa!",
  "empty_column.direct": "Tu ancor have null privat mentiones. Quande tu misse o recive un, it va aparir ci.",
  "empty_column.domain_blocks": "Ancor hay null bloccat dominias.",
  "empty_column.explore_statuses": "Nequo es popular actualmen. Retorna plu tarde!",
  "empty_column.favourited_statuses": "Tu ancor have null favorit postas. Quande tu favoritisa un, it va aparir ci.",
  "empty_column.favourites": "Ancor nequi ha favoritisat ti-ci posta. Quande alqui fa it, ilu va aparir ci.",
  "empty_column.follow_requests": "Tu ancor have null petitiones de sequer. Quande tu recive un, it va aparir ci.",
  "empty_column.followed_tags": "Tu ancor ha sequet null hashtags. Quande tu seque un, it va aparir ci.",
  "empty_column.hashtag": "Hay nullcos en ti-ci hashtag ancor.",
  "empty_column.home": "Tui hemal témpor-linea es vacui! Sequer plu gente por plenar it.",
  "empty_column.list": "Ancor ne hay quocunc in ti-ci liste. Quande membres de ti-ci liste publica nov postas, ili va aparir ci.",
  "empty_column.mutes": "Tu ancor ha silentiat null usatores.",
  "empty_column.notification_requests": "Omnicos clar! Hay necos ci. Nov notificationes va venir ci quande tu recive les secun tui parametres.",
  "empty_column.notifications": "Tu have null notificationes. Quande altri persones interacte con te, tu va vider it ci.",
  "empty_column.public": "Hay nullcos ci! Scri alquo publicmen, o manualmen seque usatores de altri servitores por plenar to-ci",
  "error.unexpected_crash.explanation": "Pro un error in nor code o un problema de compatibilitá in li navigator, ti-ci págine ne posset esser monstrat correctmen.",
  "error.unexpected_crash.explanation_addons": "Ti-ci págine ne posset esser monstrat correctmen. Li error es probabilmen causat de un extension al navigator o instrumentes por automatic traduction.",
  "error.unexpected_crash.next_steps": "Prova recargar li págine. Si to ne auxilia, tu fórsan posse usar Mastodon per un diferent navigator o aplication.",
  "error.unexpected_crash.next_steps_addons": "Prova desactivisar les e recargar li págine. Si to ne auxilia, tu fórsan posse usar Mastodon per un diferent navigator o aplication.",
  "errors.unexpected_crash.copy_stacktrace": "Copiar cumul-tracie a paperiere",
  "errors.unexpected_crash.report_issue": "Raportar un problema",
  "explore.suggested_follows": "Gente",
  "explore.trending_links": "Novas",
  "explore.trending_statuses": "Postas",
  "explore.trending_tags": "Hashtags",
  "filter_modal.added.context_mismatch_explanation": "Ti-ci filtre-categorie ne aplica al contextu in quel tu ha accessat ti-ci posta. Si tu vole que li posta es filtrat anc in ti-ci contextu, tu deve redacter li filtre.",
  "filter_modal.added.context_mismatch_title": "Contextu íncompatibil!",
  "filter_modal.added.expired_explanation": "Ti-ci filtre-categorie ha expirat, tu deve changear li date de expiration por far it aplicar.",
  "filter_modal.added.expired_title": "Expirat filtre!",
  "filter_modal.added.review_and_configure": "Por reviser e configurar ti-ci filtre-categorie, ea a {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Parametres pri filtres",
  "filter_modal.added.settings_link": "págine por parametres",
  "filter_modal.added.short_explanation": "Ti-ci post ha esset adjuntet al sequente filtre-categorie: {title}.",
  "filter_modal.added.title": "Filtre adjuntet!",
  "filter_modal.select_filter.context_mismatch": "ne aplica a ti-ci contextu",
  "filter_modal.select_filter.expired": "expirat",
  "filter_modal.select_filter.prompt_new": "Nov categorie: {name}",
  "filter_modal.select_filter.search": "Serchar o crear",
  "filter_modal.select_filter.subtitle": "Usar un existent categorie o crear nov",
  "filter_modal.select_filter.title": "Filtrar ti-ci posta",
  "filter_modal.title.status": "Filtrar un posta",
  "filtered_notifications_banner.title": "Filtrat notificationes",
  "firehose.all": "Omno",
  "firehose.local": "Ti-ci servitor",
  "firehose.remote": "Altri servitores",
  "follow_request.authorize": "Autorisar",
  "follow_request.reject": "Rejecter",
  "follow_requests.unlocked_explanation": "Benque tu conto ne es cludet, li administratores de {domain} pensat que tu fórsan vell voler tractar seque-petitiones de tis-ci contos manualmen.",
  "follow_suggestions.curated_suggestion": "Selection del employates",
  "follow_suggestions.dismiss": "Ne monstrar plu",
  "follow_suggestions.featured_longer": "Selectet manualmen del equip de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populari ínter li persones queles tu seque",
  "follow_suggestions.hints.featured": "Ti-ci profil ha esset selectet directmen del equip de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Ti-ci profil es populari ínter tis qui tu seque.",
  "follow_suggestions.hints.most_followed": "Ti-ci profil es un del max sequet sur {domain}.",
  "follow_suggestions.hints.most_interactions": "Ti-ci profil ha recivet mult atention recentmen sur {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Ti-ci profil es simil al profiles queles tu ha recentmen sequet.",
  "follow_suggestions.personalized_suggestion": "Personalisat suggestion",
  "follow_suggestions.popular_suggestion": "Populari suggestion",
  "follow_suggestions.popular_suggestion_longer": "Populari sur {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Simil a profiles queles tu sequet recentmen",
  "follow_suggestions.view_all": "Vider omnicos",
  "follow_suggestions.who_to_follow": "Persones a sequer",
  "followed_tags": "Sequet hashtags",
  "footer.about": "Information",
  "footer.directory": "Profilarium",
  "footer.get_app": "Obtener li aplication",
  "footer.keyboard_shortcuts": "Rapid-tastes",
  "footer.privacy_policy": "Politica pri privatie",
  "footer.source_code": "Vider li fonte-code",
  "footer.status": "Statu",
  "generic.saved": "Conservat",
  "getting_started.heading": "Qualmen comensar",
  "hashtag.column_header.tag_mode.all": "e {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "sin {additional}",
  "hashtag.column_settings.select.no_options_message": "Null suggestiones trovat",
  "hashtag.column_settings.select.placeholder": "Inscrir hashtags…",
  "hashtag.column_settings.tag_mode.all": "Omni tis",
  "hashtag.column_settings.tag_mode.any": "Quelcunc de tis",
  "hashtag.column_settings.tag_mode.none": "Necun de tis",
  "hashtag.column_settings.tag_toggle": "Include additional hashtags in ti-ci columne",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participante} other {{counter} participantes}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} posta} other {{counter} postas}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} posta} other {{counter} postas}} hodie",
  "hashtag.follow": "Sequer hashtag",
  "hashtag.unfollow": "Dessequer hashtag",
  "hashtags.and_other": "…e {count, plural, other {# in plu}}",
  "home.column_settings.show_reblogs": "Monstrar boosts",
  "home.column_settings.show_replies": "Monstrar responses",
  "home.hide_announcements": "Celar proclamationes",
  "home.pending_critical_update.body": "Ples actualisar tui Mastodon-servitor tam rapid quam es possibil!",
  "home.pending_critical_update.link": "Vider actualisationes",
  "home.pending_critical_update.title": "Urgent actualisation de securitá disponibil!",
  "home.show_announcements": "Monstrar proclamationes",
  "interaction_modal.on_another_server": "Sur un servitor diferent",
  "interaction_modal.on_this_server": "Sur ti-ci servitor",
  "intervals.full.days": "{number, plural, one {# die} other {# dies}}",
  "intervals.full.hours": "{number, plural, one {# hor} other {# hores}}",
  "intervals.full.minutes": "{number, plural, one {# minute} other {# minutes}}",
  "keyboard_shortcuts.back": "Retroear",
  "keyboard_shortcuts.blocked": "Aperter li lista de bloccat usatores",
  "keyboard_shortcuts.boost": "Boostar posta",
  "keyboard_shortcuts.column": "Infocar columne",
  "keyboard_shortcuts.compose": "Infocar li text-area de composition",
  "keyboard_shortcuts.description": "Descrition",
  "keyboard_shortcuts.down": "Mover ad-infra in li liste",
  "keyboard_shortcuts.enter": "Aperter posta",
  "keyboard_shortcuts.favourite": "Favoritisar posta",
  "keyboard_shortcuts.favourites": "Aperter li liste de favorites",
  "keyboard_shortcuts.federated": "Aperter li federat témpor-linea",
  "keyboard_shortcuts.heading": "Rapid-tastes",
  "keyboard_shortcuts.home": "Aperter li hemal témpor-linea",
  "keyboard_shortcuts.hotkey": "Rapid clave",
  "keyboard_shortcuts.legend": "Monstrar ti-ci legende",
  "keyboard_shortcuts.local": "Aperter li local témpor-linea",
  "keyboard_shortcuts.mention": "Mentionar li autor",
  "keyboard_shortcuts.muted": "Aperter li lista de silentiat usatores",
  "keyboard_shortcuts.my_profile": "Aperter tui profil",
  "keyboard_shortcuts.notifications": "Aperter li columne de notificationes",
  "keyboard_shortcuts.open_media": "Aperter medie",
  "keyboard_shortcuts.pinned": "Aperter li liste de pinglat postas",
  "keyboard_shortcuts.profile": "Aperter profil del autor",
  "keyboard_shortcuts.reply": "Responder al posta",
  "keyboard_shortcuts.requests": "Aperter liste de seque-petitiones",
  "keyboard_shortcuts.search": "Infocar sercha-barre",
  "keyboard_shortcuts.spoilers": "Monstrar/celar CW camp",
  "keyboard_shortcuts.start": "Aperter \"Qualmen comensar\" columne",
  "keyboard_shortcuts.toggle_hidden": "Monstrar/celar text detra CW",
  "keyboard_shortcuts.toggle_sensitivity": "Monstrar/celar medie",
  "keyboard_shortcuts.toot": "Crear un nov posta",
  "keyboard_shortcuts.unfocus": "Desinfocar text-area de composition/serchar",
  "keyboard_shortcuts.up": "Mover ad-supra in li liste",
  "lightbox.close": "Cluder",
  "lightbox.next": "Sequent",
  "lightbox.previous": "Precedent",
  "limited_account_hint.action": "Monstrar profil totvez",
  "limited_account_hint.title": "Ti-ci profil ha esset celat del moderatores de {domain}.",
  "link_preview.author": "De {name}",
  "lists.delete": "Deleter liste",
  "lists.edit": "Redacter liste",
  "lists.replies_policy.followed": "Quelcunc sequet usator",
  "lists.replies_policy.list": "Membres del liste",
  "lists.replies_policy.none": "Nequi",
  "load_pending": "{count, plural, one {# nov element} other {# nov elementes}}",
  "loading_indicator.label": "Cargant…",
  "moved_to_account_banner.text": "Tui conto {disabledAccount} es actualmen desactivisat pro que tu movet te a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Celar de notificationes",
  "mute_modal.hide_options": "Celar optiones",
  "mute_modal.indefinite": "Til quande yo dessilentia li usator",
  "mute_modal.show_options": "Monstrar optiones",
  "mute_modal.they_can_mention_and_follow": "Posse mentionar e sequer te, ma va esser ínvisibil a te.",
  "mute_modal.they_wont_know": "Ne va esser conscient pri li silentation.",
  "mute_modal.title": "Silentiar usator?",
  "mute_modal.you_wont_see_mentions": "Tu ne va vider postas mentionant li usator.",
  "mute_modal.you_wont_see_posts": "Ne posse vider tui postas e inversi.",
  "navigation_bar.about": "Information",
  "navigation_bar.advanced_interface": "Aperter in li web-interfacie avansat",
  "navigation_bar.blocks": "Bloccat usatores",
  "navigation_bar.bookmarks": "Marcatores",
  "navigation_bar.direct": "Privat mentiones",
  "navigation_bar.domain_blocks": "Bloccat dominias",
  "navigation_bar.favourites": "Favorites",
  "navigation_bar.filters": "Silentiat paroles",
  "navigation_bar.follow_requests": "Petitiones de sequer",
  "navigation_bar.followed_tags": "Sequet hashtags",
  "navigation_bar.follows_and_followers": "Sequetes e sequitores",
  "navigation_bar.lists": "Listes",
  "navigation_bar.logout": "Exear",
  "navigation_bar.mutes": "Silentiat usatores",
  "navigation_bar.opened_in_classic_interface": "Postas, contos e altri specific págines es customalmen apertet in li classic web-interfacie.",
  "navigation_bar.preferences": "Preferenties",
  "navigation_bar.search": "Sercha",
  "not_signed_in_indicator.not_signed_in": "On deve aperter session por accesser ti-ci ressurse.",
  "notification.admin.report": "{name} raportat {target}",
  "notification.admin.sign_up": "{name} adheret",
  "notification.favourite": "{name} favoritisat tui posta",
  "notification.follow": "{name} sequet te",
  "notification.follow_request": "{name} ha petit sequer te",
  "notification.moderation-warning.learn_more": "Aprender plu",
  "notification.moderation_warning": "Tu ha recivet un moderatori advertiment",
  "notification.moderation_warning.action_delete_statuses": "Alcun de tui postas ha esset efaciat.",
  "notification.moderation_warning.action_disable": "Tui conto ha esset desactivisat.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Alcun de tui postas ha esset marcat quam sensitiv.",
  "notification.moderation_warning.action_none": "Tui conto ha recivet un moderatori advertiment.",
  "notification.moderation_warning.action_sensitive": "Desde nu tui postas va esser marcat quam sensitiv.",
  "notification.moderation_warning.action_silence": "Tui conto ha esset limitat.",
  "notification.moderation_warning.action_suspend": "Tui conto ha esset suspendet.",
  "notification.own_poll": "Tui balotation ha finit",
  "notification.reblog": "{name} boostat tui posta",
  "notification.relationships_severance_event": "Perdit conexiones con {name}",
  "notification.relationships_severance_event.account_suspension": "Un admin de {from} ha suspendet {target}, dunc con ti person tu ne plu posse reciver actualisationes ni far interactiones.",
  "notification.relationships_severance_event.domain_block": "Un admin de {from} ha bloccat {target}, includente {followersCount} de tui sequitores e {followingCount, plural, one {# conto} other {# contos}} sequet de te.",
  "notification.relationships_severance_event.learn_more": "Aprender plu",
  "notification.relationships_severance_event.user_domain_block": "Tu ha bloccat {target}, efaciante {followersCount} de tui sequitores e {followingCount, plural, one {# conto} other {# contos}} sequet de te.",
  "notification.status": "{name} just postat",
  "notification.update": "{name} modificat un posta",
  "notification_requests.accept": "Acceptar",
  "notification_requests.dismiss": "Demisser",
  "notification_requests.notifications_from": "Notificationes de {name}",
  "notification_requests.title": "Filtrat notificationes",
  "notifications.clear": "Aclarar notificationes",
  "notifications.clear_confirmation": "Vole tu vermen permanentmen aclarar omni tui notificationes?",
  "notifications.column_settings.admin.report": "Nov raportas:",
  "notifications.column_settings.admin.sign_up": "Nov registrationes:",
  "notifications.column_settings.alert": "Notificationes sur li computator",
  "notifications.column_settings.favourite": "Favorites:",
  "notifications.column_settings.filter_bar.advanced": "Monstrar omni categories",
  "notifications.column_settings.filter_bar.category": "Rapid filtre-barre",
  "notifications.column_settings.follow": "Nov sequitores:",
  "notifications.column_settings.follow_request": "Nov petitiones de sequer:",
  "notifications.column_settings.mention": "Mentiones:",
  "notifications.column_settings.poll": "Resultates del balotation:",
  "notifications.column_settings.push": "Notificationes push",
  "notifications.column_settings.reblog": "Boosts:",
  "notifications.column_settings.show": "Monstrar in columne",
  "notifications.column_settings.sound": "Far son",
  "notifications.column_settings.status": "Nov postas:",
  "notifications.column_settings.unread_notifications.category": "Ínleet notificationes",
  "notifications.column_settings.unread_notifications.highlight": "Marcar ínleet notificationes",
  "notifications.column_settings.update": "Redactiones:",
  "notifications.filter.all": "Omni",
  "notifications.filter.boosts": "Boosts",
  "notifications.filter.favourites": "Favorites",
  "notifications.filter.follows": "Seques",
  "notifications.filter.mentions": "Mentiones",
  "notifications.filter.polls": "Resultates del balotation",
  "notifications.filter.statuses": "Actualisationes de gente quem tu seque",
  "notifications.grant_permission": "Dar permission.",
  "notifications.group": "{count} notificationes",
  "notifications.mark_as_read": "Marcar omni notificationes quam leet",
  "notifications.permission_denied": "Notificationes sur li computator es índisponibil pro que on ha previamen rejectet un petition por navigator-permissiones",
  "notifications.permission_denied_alert": "Notificationes sur li computator ne posse esser activisat, pro que navigator-permission ha esset previamen rejectet",
  "notifications.permission_required": "Notificationes sur li computator es índisponibil pro que li besonat permission ne ha esset dat.",
  "notifications.policy.filter_new_accounts.hint": "Creat durant li passat {days, plural, one {un die} other {# dies}}",
  "notifications.policy.filter_new_accounts_title": "Nov contos",
  "notifications.policy.filter_not_followers_hint": "Includente tis qui ha sequet te minu quam {days, plural, one {un die} other {# dies}}",
  "notifications.policy.filter_not_followers_title": "Persones qui ne seque te",
  "notifications.policy.filter_not_following_hint": "Til quande tu manualmen aproba",
  "notifications.policy.filter_not_following_title": "Persones queles tu ne seque",
  "notifications.policy.filter_private_mentions_hint": "Filtrat except si it es un response a tui propri mention o si tu seque li missor",
  "notifications.policy.filter_private_mentions_title": "Ínsolicitat privat mentiones",
  "notifications_permission_banner.enable": "Activisar notificationes sur li computator",
  "notifications_permission_banner.how_to_control": "Por reciver notificationes quande Mastodon ne es apert, activisa notificationes sur li computator. Tu posse decider precisimen quel species de interactiones genera notificationes per li buton {icon} in-supra quande ili es activisat.",
  "notifications_permission_banner.title": "Nequande preterlassa quocunc",
  "onboarding.follows.empty": "Ínfortunatmen, null resultates posse esser monstrat actualmen. Tu posse provar serchar o usar li \"Explorar\" págine por trovar gente por sequer, o prova denov plu tard.",
  "onboarding.profile.discoverable": "Fa mi profil decovribil",
  "onboarding.profile.discoverable_hint": "Quande tu opta esser decovribil in Mastodon, tui postas posse aparir in resultates de sercha e tendenties, e tui profil posse esser suggestet a persones con interesses simil a tui.",
  "onboarding.profile.display_name": "Nómine a monstrar",
  "onboarding.profile.display_name_hint": "Tui complet nómine o tui amusant nómine…",
  "onboarding.profile.note": "Biografie",
  "onboarding.profile.note_hint": "Tu posse @mentionar altri persones o #hashtags…",
  "onboarding.profile.title": "Popular tu profil",
  "onboarding.profile.upload_avatar": "Cargar profil-portrete",
  "onboarding.profile.upload_header": "Cargar cap-image",
  "password_confirmation.exceeds_maxlength": "Confirmation de passa-parol transpassa li maxim longore de passa-paroles",
  "password_confirmation.mismatching": "Confirmation de passa-parol ne egala",
  "picture_in_picture.restore": "Restaurar",
  "poll.closed": "Finit",
  "poll.refresh": "Recargar",
  "poll.reveal": "Vider resultates",
  "poll.total_people": "{count, plural, one {# person} other {# persones}}",
  "poll.total_votes": "{count, plural, one {# vote} other {# votes}}",
  "poll.vote": "Votar",
  "poll.voted": "Tu votat por ti-ci option",
  "poll.votes": "{votes, plural, one {# vote} other {# votes}}",
  "poll_button.add_poll": "Adjunter un balotation",
  "poll_button.remove_poll": "Remover balotation",
  "privacy.change": "Changear li privatie del posta",
  "privacy.direct.long": "Omnes mentionat in li posta",
  "privacy.private.long": "Solmen tui sequitores",
  "privacy.private.short": "Sequitores",
  "privacy.public.long": "Quicunc in e ex Mastodon",
  "privacy.public.short": "Public",
  "privacy.unlisted.additional": "It acte just quam public, except que li posta ne va aparir in tendentie o hashtags, explorar, o sercha de Mastodon, mem si tu ha optet por les sur tui tot conto.",
  "privacy.unlisted.short": "Quiet public",
  "privacy_policy.last_updated": "Ultimmen actualisat ye {date}",
  "privacy_policy.title": "Politica pri Privatie",
  "recommended": "Recomandat",
  "refresh": "Recargar",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "Ante {number, plural, one {# die} other {# dies}}",
  "relative_time.full.hours": "Ante {number, plural, one {# hor} other {# hores}}",
  "relative_time.full.just_now": "just nu",
  "relative_time.full.minutes": "Ante {number, plural, one {# minute} other {# minutes}}",
  "relative_time.full.seconds": "Ante {number, plural, one {# second} other {# secondes}}",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "nu",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hodie",
  "reply_indicator.attachments": "{count, plural, one {# atachament} other {# atachamentes}}",
  "reply_indicator.cancel": "Anullar",
  "reply_indicator.poll": "Balotar",
  "report.block": "Bloccar",
  "report.block_explanation": "Tu ne va vider su postas. Li usator ni va posser vider tui postas, ni sequer te, ni va posser saver pri li statu de esser bloccat.",
  "report.categories.legal": "Legal",
  "report.categories.other": "Altricos",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Contenete violant un o pluri regules del servitor",
  "report.category.subtitle": "Selecte li max bon option",
  "report.category.title": "Di nos quo passa con ti-ci {type}",
  "report.category.title_account": "profil",
  "report.category.title_status": "posta",
  "report.close": "Finit",
  "report.comment.title": "Hay alquo plu quel tu pensa que noi deve saver?",
  "report.forward": "Misser anc a {target}",
  "report.forward_hint": "Ti-ci conto es de un altri servitor. Misser un anonimisat copie del raporte anc a ta?",
  "report.mute": "Silentiar",
  "report.mute_explanation": "Tu ne va vider su postas. Ilu ancor posse sequer te e vider tui postas e ne va saver que ilu es silentiat.",
  "report.next": "Sequent",
  "report.placeholder": "Additional comentas",
  "report.reasons.dislike": "It ne plese me",
  "report.reasons.dislike_description": "It es alquo quel displese te",
  "report.reasons.legal": "It es ínlegal",
  "report.reasons.legal_description": "Tu crede que it viola un lege del land de te o de tui servitor",
  "report.reasons.other": "It es altricos",
  "report.reasons.other_description": "Li problema ne apartene in li altri categories",
  "report.reasons.spam": "It es spam",
  "report.reasons.spam_description": "Maliciosi ligamentes, fals activitá, o repetitiv responses",
  "report.reasons.violation": "It viola li regules del servitor",
  "report.reasons.violation_description": "Tu save que it viola specific regules",
  "report.rules.subtitle": "Selecte omnes queles aplica",
  "report.rules.title": "Quel regules es violat?",
  "report.statuses.subtitle": "Selecte omnes queles aplica",
  "report.statuses.title": "Hay postas queles posse subtener ti-ci raporte?",
  "report.submit": "Misser",
  "report.target": "Raportant {target}",
  "report.thanks.take_action": "Tis-ci es tui optiones por controlar ti quel tu vide che Mastodon:",
  "report.thanks.take_action_actionable": "Durante que noi tracta ti-ci, tu posse far lu sequent contra @{name}:",
  "report.thanks.title": "Vole tu ne vider to?",
  "report.thanks.title_actionable": "Mersí pro raportar, noi va investigar to.",
  "report.unfollow": "Dessequer @{name}",
  "report.unfollow_explanation": "Tu seque ti-ci conto. Por ne vider su postas en tui hemal témpor-linea, dessequer it.",
  "report_notification.attached_statuses": "{count, plural, one {{count} posta} other {{count} postas}} atachat",
  "report_notification.categories.legal": "Legal",
  "report_notification.categories.other": "Altricos",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.violation": "Violation de regul",
  "report_notification.open": "Aperter raporta",
  "search.no_recent_searches": "Null recent serchas",
  "search.placeholder": "Serchar",
  "search.quick_action.account_search": "Profiles acordant con {x}",
  "search.quick_action.go_to_account": "Ear al profil {x}",
  "search.quick_action.go_to_hashtag": "Ear al hashtag {x}",
  "search.quick_action.open_url": "Aperter URL in Mastodon",
  "search.quick_action.status_search": "Postas acordant con {x}",
  "search.search_or_paste": "Serchar o glutinar URL",
  "search_popout.full_text_search_disabled_message": "Ne disponibil che {domain}.",
  "search_popout.full_text_search_logged_out_message": "Solmen disponibil con session initiat.",
  "search_popout.language_code": "Code de lingue ISO",
  "search_popout.options": "Sercha-parametres",
  "search_popout.quick_actions": "Rapid actiones",
  "search_popout.recent": "Recent serchas",
  "search_popout.specific_date": "specific date",
  "search_popout.user": "usator",
  "search_results.accounts": "Profiles",
  "search_results.all": "Omni",
  "search_results.hashtags": "Hashtags",
  "search_results.see_all": "Vider omni",
  "search_results.statuses": "Postas",
  "server_banner.about_active_users": "Gente usant ti-ci servitor durant li ultim 30 dies (Mensual Activ Usatores)",
  "server_banner.active_users": "activ usatores",
  "server_banner.administered_by": "Administrat de:",
  "server_banner.server_stats": "Statisticas pri li servitor:",
  "sign_in_banner.create_account": "Crear un conto",
  "sign_in_banner.sign_in": "Intrar",
  "sign_in_banner.sso_redirect": "Intrar o registrar se",
  "status.admin_account": "Aperter interfacie de moderation por @{name}",
  "status.admin_domain": "Aperter interfacie de moderation por {domain}",
  "status.admin_status": "Aperter ti-ci posta in li interfacie de moderation",
  "status.block": "Bloccar @{name}",
  "status.bookmark": "Marcar",
  "status.cancel_reblog_private": "Desboostar",
  "status.cannot_reblog": "Ti-ci posta ne posse esser boostat",
  "status.copy": "Copiar ligament al posta",
  "status.delete": "Deleter",
  "status.detailed_status": "Detalliat vise de conversation",
  "status.direct": "Privatmen mentionar @{name}",
  "status.direct_indicator": "Privat mention",
  "status.edit": "Modificar",
  "status.edited": "Ultimmen actualisat ye {date}",
  "status.edited_x_times": "Modificat {count, plural, one {{count} vez} other {{count} vezes}}",
  "status.favourite": "Favoritisar",
  "status.filter": "Filtrar ti-ci posta",
  "status.history.created": "creat de {name} ye {date}",
  "status.history.edited": "modificat de {name} ye {date}",
  "status.load_more": "Cargar plu",
  "status.media.open": "Cliccar por aperter",
  "status.media.show": "Cliccar por monstrar",
  "status.media_hidden": "Medie celat",
  "status.mention": "Mentionar @{name}",
  "status.more": "Plu",
  "status.mute": "Silentiar @{name}",
  "status.mute_conversation": "Silentiar conversation",
  "status.open": "Expander ti-ci posta",
  "status.pin": "Pinglar sur profil",
  "status.read_more": "Leer plu",
  "status.reblog": "Boostar",
  "status.reblogged_by": "{name} boostat",
  "status.reblogs.empty": "Ancor nequi ha boostat ti-ci posta. Quande alqui fa it, ilu va aparir ci.",
  "status.redraft": "Deleter & redacter",
  "status.remove_bookmark": "Remover marcator",
  "status.replied_to": "Respondet a {name}",
  "status.reply": "Responder",
  "status.replyAll": "Responder al fil",
  "status.report": "Raportar @{name}",
  "status.sensitive_warning": "Sensitiv contenete",
  "status.share": "Partir",
  "status.show_less_all": "Monstrar minu por omno",
  "status.show_more_all": "Monstrar plu por omno",
  "status.show_original": "Monstrar li original",
  "status.title.with_attachments": "{user} postat {attachmentCount, plural, one {un atachament} other {{attachmentCount} atachamentes}}",
  "status.translate": "Traducter",
  "status.translated_from_with": "Traductet de {lang} per {provider}",
  "status.uncached_media_warning": "Previse ne disponibil",
  "status.unmute_conversation": "Dessilentiar conversation",
  "status.unpin": "Despinglar de profil",
  "subscribed_languages.lead": "Solmen postas in selectet lingues va aparir in tui hemal e listal témpor-lineas pos li change. Selecte null por reciver postas in omni lingues.",
  "subscribed_languages.save": "Conservar changes",
  "subscribed_languages.target": "Changear abonnat lingues por {target}",
  "tabs_bar.home": "Hem",
  "tabs_bar.notifications": "Notificationes",
  "time_remaining.days": "{number, plural, one {# die} other {# dies}} resta",
  "time_remaining.hours": "{number, plural, one {# hor} other {# hores}} resta",
  "time_remaining.minutes": "{number, plural, one {# minute} other {# minutes}} resta",
  "time_remaining.moments": "Momentes resta",
  "time_remaining.seconds": "{number, plural, one {# second} other {# secondes}} resta",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} persones}} durant li ultim {days, plural, one {die} other {{days} dies}}",
  "trends.trending_now": "Actualmen populari",
  "ui.beforeunload": "Tui íncomplet posta va esser perdit si tu lassa Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Trenar & lassar cader por cargar",
  "upload_button.label": "Adjunter images, un video o un audio-file",
  "upload_error.limit": "Límite de medie-cargationes transpassat.",
  "upload_error.poll": "On ne es permisset cargar medie con balotationes.",
  "upload_form.edit": "Redacter",
  "upload_progress.label": "Cargant...",
  "upload_progress.processing": "Tractant…",
  "username.taken": "Ti usator-nómine es ja prendet. Trova altri",
  "video.close": "Cluder video",
  "video.download": "Descargar file",
  "video.exit_fullscreen": "Exear plen-ecran",
  "video.expand": "Expander video",
  "video.fullscreen": "Plen-ecran",
  "video.hide": "Celar video",
  "video.pause": "Pausar",
  "video.play": "Reproducter"
}
